export default "__VITE_ASSET__C7BWKzam__"